export enum OccupierTplTypeEnum {
  operator = 'operator',
  occupant = 'occupant',
  tenant = 'tenant',
}
